import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PinIcon from '@mui/icons-material/LocationOn';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {
  formatProviderName,
  isPersonalTrainer,
  getPublicProfileUrl,
  getProfileImage,
} from '../../helpers/providers';
import {getSpecialties} from '../../helpers/selectOptions';
import CustomChip from '../common/CustomChip';
import CustomTextField from '../common/CustomTextField';

const ListProvidersScreen = ({providers, onFilterChange}) => {
  console.log('PROVIDERS', providers);
  return (
    <Box>
      <Stack spacing={3} padding={3}>
        <Typography variant='h1' component='h1' align='center' padding={1}>
          Browse Physical Therapists and Personal Trainers
        </Typography>
        <Stack direction='row' justifyContent='center' paddingTop='1em'>
          <CustomTextField
            size='small'
            onChange={e => onFilterChange(e, {text: e.target.value})}
            placeholder='Search by name, city, zip code, or state'
            sx={{minWidth: 350}}
            InputProps={{
              startAdornment: <InputAdornment position="start">
                <SearchIcon color='primary' />
              </InputAdornment>
            }}
          />
        </Stack>
        <Grid container spacing={2}>
          {
            (providers || []).map(p =>
              <Grid item xs={12} sm={6} md={4} lg={3} key={p.id}>
                <Card sx={{minHeight: 400}}>
                  <CardMedia
                    sx={{height: 250}}
                    image={getProfileImage(p)}
                    title={`${formatProviderName(p)} headshot`}
                  />
                  <CardContent>
                    <Button 
                      variant='text' 
                      component='a' 
                      href={getPublicProfileUrl(p)} 
                      key={p.id} 
                      paddingRight={0}
                    >
                      <Typography variant='h2' component='h2' align='center'>
                        {formatProviderName(p)}
                      </Typography>
                    </Button>
                    <Stack paddingLeft={0.75} paddingRight={.75} gap={1.5}>
                      <Typography variant='h3' component='h3' color='text.light'>
                        {isPersonalTrainer(p) ? 'Personal Trainer' : 'Physical Therapist'}
                      </Typography>
                      {p?.location_strings?.length 
                          ? <Stack direction='row' gap={1} flexWrap='wrap' alignItems='center'>
                            <PinIcon color='light' />
                            <Typography variant='body1' color='text.light'>Locations</Typography>
                            {(p?.location_strings || []).map(s => 
                              <CustomChip key={s} label={s} />
                            )}
                          </Stack>
                        : null
                      }
                      {p?.specialtyCategories?.length
                        ? <Stack direction='row' gap={1} flexWrap='wrap' alignItems='center'>
                          <MedicalServicesIcon color='light' />
                          <Typography variant='body1' color='text.light'>Specialties</Typography>
                          {(p?.specialtyCategories || []).map(s => 
                            <CustomChip 
                              key={s} 
                              label={getSpecialties().find(opt => opt.value === s)?.label}
                              variant='outlined' 
                              color='primary'
                            />
                          )}
                        </Stack>
                        : null
                      }
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ) 
          }
        </Grid>

      </Stack>
    </Box>
  );
};

export default ListProvidersScreen;